export default "__VITE_ASSET__DWXqJRI7__"